import * as React from "react";
// import ButtonAddToBasket from "~/components/button-add-to-basket/button-add-to-basket";
import classNames from "classnames";
import { IProduct, PriceTypesEnum } from "~/types/product";
import CtaButton from "~/components/cta-button/cta-button";
// import Icon from "../icons/icon";
import { pushClickTrackingEvent, pushImpressionViewTrackingEvent } from "~/utils/tracking-utils";
import { useInView } from "react-intersection-observer";
import ProductAuthors from "../product-authors/product-authors";
// import { useSelector } from "react-redux";
// import { selectIsOutOfStock } from "~/store/reducers/basket/basket-reducer";
// import { IRootState } from "~/store/reducers";
// import ErrorMessage from "../error-message/error-message";
import ProductTileImage from "./product-tile-image";
import ProductTileTitle from "./product-tile-title";
// import { IDiscountOffer } from "~/types/discount-offer";
// import DiscountModal from "../product-details/discount-modal/discount-modal";
// import ProductDiscountSplash from "../product-discount-splash/product-discount-splash";
// import { hasDeclinedDiscountThisOffer } from "~/utils/discount-utils";

export interface IProductTileProps extends IProduct {
    className?: string;
    hideBackground?: boolean;
    hideStatus?: boolean;
    hideAuthors?: boolean;
    hasTopPadding?: boolean;
    // bottomPaddedSubText?: boolean;
    // hasBottomPaddingNumberOfProducts?: boolean;
    ctaLabel?: string;
    ctaLink?: string;
    detailsLabel?: string;
    hasQuickView?: boolean;
    onQuickViewClick?: () => void;
    // addToBasketWebApiUrl?: string;
    // secondaryPriceLabel?: string;
    sizes?: string;
    trackingPosition?: number;
    // discountOffer?: IDiscountOffer;
    trackingList: string;
    showCtaAsLink?: boolean;
    singleItemHighlight?: boolean;
    btnIsLarge?: boolean;
    description?: string;
    // showDiscountOfferModal?: boolean;
}

export interface IProductTileChildProps {
    baseClass: string;
    onClick: () => void;
}

const ProductTile: React.FC<IProductTileProps> = ({
    // addToBasketWebApiUrl,
    authors,
    // bottomPaddedSubText,
    btnIsLarge,
    className,
    // ctaLabel,
    ctaLink,
    description,
    detailsLabel,
    // discount,
    // discountOffer,
    // hasBottomPaddingNumberOfProducts,
    hasQuickView,
    hasTopPadding,
    hideAuthors,
    hideBackground,
    hideStatus,
    imageFallbackSrc,
    imageSrcSet,
    // materialType,
    // numberOfProductsLabel,
    onQuickViewClick,
    productId,
    // secondaryPrice,
    // secondaryPriceLabel,
    showCtaAsLink,
    singleItemHighlight,
    sizes,
    status,
    statusLabel,
    // stockStatusLabel,
    target,
    title,
    trackingList,
    trackingPosition,
    url
    // showDiscountOfferModal = false,
    // ...props
}) => {
    // const isOutOfStock = useSelector((state: IRootState) => selectIsOutOfStock(state, productId));
    // const [discountModalOpen, setDiscountModalOpen] = React.useState(false);

    // const onAddToBasket = () => {
    //     if (!discountOffer) {
    //         return;
    //     }

    //     if (hasDeclinedDiscountThisOffer(discountOffer)) {
    //         return;
    //     }

    //     if (!showDiscountOfferModal) {
    //         return;
    //     }

    //     setDiscountModalOpen(true);
    // };

    const baseClass = "product-tile";
    const classes = classNames(baseClass, className, {
        [`${baseClass}--noBackground`]: hideBackground,
        [`${baseClass}--hasQuickView`]: hasQuickView,
        [`${baseClass}--spot`]: status === PriceTypesEnum.SPOT,
        [`${baseClass}--topPadded`]: hasTopPadding,
        // [`${baseClass}--bottomPaddedSubText`]: bottomPaddedSubText,
        // [`${baseClass}--bottomPaddedNumberOfProducts`]: hasBottomPaddingNumberOfProducts,
        [`${baseClass}--singleProduct`]: singleItemHighlight
    });

    const [ref, inView] = useInView({
        triggerOnce: true
    });

    const clickTrackingEvent = () =>
        pushClickTrackingEvent({
            productId,
            title,
            trackingList,
            trackingPosition
        });

    React.useEffect(() => {
        if (inView && trackingPosition) {
            pushImpressionViewTrackingEvent([
                {
                    productId,
                    title,
                    trackingList,
                    trackingPosition
                }
            ]);
        }
    }, [inView]);

    const onTileClick = () => {
        if (hasQuickView) {
            onQuickViewClick?.();
        } else {
            clickTrackingEvent();
        }
    };
    // const bottomClasses = classNames(`${baseClass}__bottom`, {
    //     [`${baseClass}__bottom--subText`]: secondaryPrice || stockStatusLabel,
    //     [`${baseClass}__bottom--numberOfProducts`]: numberOfProductsLabel
    // });

    return (
        <div id={`product-${productId}`} className={classes} ref={ref}>
            {/* {showDiscountOfferModal && discountOffer && (
                <DiscountModal
                    // disableWebApiUrl={disableDiscountOfferWebApiUrl}
                    isOpen={discountModalOpen}
                    setOpen={setDiscountModalOpen}
                    addToBasketWebApiUrl={addToBasketWebApiUrl}
                    discount={discountOffer}
                    secondaryPriceLabel={secondaryPriceLabel}
                    {...props}
                />
            )} */}
            <ProductTileImage
                status={status}
                statusLabel={statusLabel}
                hideStatus={hideStatus}
                hasQuickView={hasQuickView}
                onClick={onTileClick}
                baseClass={baseClass}
                url={url}
                target={target}
                title={title}
                detailsLabel={detailsLabel}
                imageSrcSet={imageSrcSet}
                imageFallbackSrc={imageFallbackSrc}
                sizes={sizes}
                // discount={discount}
            />
            {/* {singleItemHighlight && discount && (
                <ProductDiscountSplash className={`${baseClass}__discount-splash`} discount={discount} />
            )} */}
            <div className={`${baseClass}__info-container`}>
                <div className={`${baseClass}__info`}>
                    <ProductTileTitle
                        hasQuickView={hasQuickView}
                        baseClass={baseClass}
                        title={title}
                        url={url}
                        target={target}
                        onClick={onTileClick}
                    />
                    {!hideAuthors && (
                        <ProductAuthors
                            className={`${baseClass}__product-authors`}
                            authors={authors}
                            maxLines={1}
                        />
                    )}
                    {/* {materialType && <span className={`${baseClass}__material-type`}>{materialType}</span>} */}
                    {singleItemHighlight && description && (
                        <div
                            className={`${baseClass}__description`}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}
                </div>
                {!singleItemHighlight && ctaLink && (
                    <>
                        {showCtaAsLink ? (
                            <div
                                onClick={() => {
                                    if (!hasQuickView) {
                                        clickTrackingEvent();
                                    }
                                }}
                                className={`${baseClass}__cta-link`}
                                dangerouslySetInnerHTML={{ __html: ctaLink }}
                            />
                        ) : (
                            <CtaButton
                                onClick={() => {
                                    if (!hasQuickView) {
                                        clickTrackingEvent();
                                    }
                                }}
                                className={`${baseClass}__button`}
                                link={ctaLink}
                                isLarge={btnIsLarge ?? true}
                            />
                        )}
                    </>
                )}
                {/* {addToBasketWebApiUrl && !ctaLink && (
                    <ButtonAddToBasket
                        className={`${baseClass}__button`}
                        addToBasketWebApiUrl={addToBasketWebApiUrl}
                        productId={productId}
                        trackingList={trackingList}
                        disabled={isOutOfStock.value}
                        isLarge={btnIsLarge ?? true}
                        onAdd={onAddToBasket}
                    >
                        {ctaLabel}
                    </ButtonAddToBasket>
                )} */}
                {/* {(secondaryPrice || stockStatusLabel || numberOfProductsLabel) && (
                    <div className={bottomClasses}>
                        {isOutOfStock.value && isOutOfStock.error && (
                            <ErrorMessage
                                className={`${baseClass}__sub-text`}
                                errorSeverity="error"
                                errorMessage={isOutOfStock.error}
                            />
                        )}
                        {secondaryPriceLabel && secondaryPrice && (
                            <div className={`${baseClass}__sub-text ${baseClass}__secondary-price`}>
                                {secondaryPriceLabel} {secondaryPrice}
                            </div>
                        )}
                        {stockStatusLabel && (
                            <div className={`${baseClass}__sub-text ${baseClass}__stock-status`}>
                                {stockStatusLabel}
                            </div>
                        )}

                        {numberOfProductsLabel && (
                            <div className={`${baseClass}__number-of-products`}>
                                <Icon iconId="32_katalog" />
                                <span>{numberOfProductsLabel}</span>
                            </div>
                        )}
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default React.memo(ProductTile);
